import React from "react";
import { fmtClock, sumSeconds } from "@/components/shownotes/meta";

// Read-only scene run list with total, for the note viewer.
export default function SceneRunView({ scenes }) {
  if (!scenes?.length) return <p className="text-sm text-slate-800" data-testid="note-view-scenes">—</p>;
  return (
    <div className="overflow-hidden rounded-md border border-slate-200 text-sm" data-testid="note-view-scenes">
      {scenes.map((s, i) => (
        <div key={i} className="flex justify-between gap-3 border-b border-slate-100 px-3 py-1.5" data-testid={`note-view-scene-${i}`}>
          <span className="text-slate-800">{s.scene || `Scene ${i + 1}`}</span>
          <span className="tabular-nums text-slate-600">{fmtClock(s.seconds)}</span>
        </div>
      ))}
      <div className="flex justify-between gap-3 bg-slate-100 px-3 py-1.5 font-bold text-slate-900">
        <span>Total scene time</span>
        <span className="tabular-nums" data-testid="note-view-scenes-total">{fmtClock(sumSeconds(scenes.map((s) => s.seconds)))}</span>
      </div>
    </div>
  );
}
